import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { AuthConsumer } from '../context/AuthContext';
import FETCH from '../Fetch';
import { toast } from './Notifier';
import { numberFormat, getDueTime, canDisableFee } from '../utils';
import { DaysRemainingIcon } from './Svg';

// imports for all images used in dashboard component
import academicDetails from '../assets/academic-details.svg';
// import daysRemainingIcon from '../assets/days-remaining-icon.svg';
import transactionSuccess from '../assets/transaction-success.svg';
import transactionPending from '../assets/transaction-pending.svg';
import courseMinimumUnits from '../assets/course-minimum-units.svg';
import courseMaximumUnits from '../assets/course-maximum-units.svg';
import courseTotalUnits from '../assets/course-total-unit.svg';
import courseOutstanding from '../assets/course-outstanding.svg';

// imoprt all Loader components for loading
import DashboardOutstandingFeesLoader from '../loaderComponents/DashboardOutstandingFeesLoader';
import DashboardLastTransactionsLoader from '../loaderComponents/DashboardLastTransactionsLoader';
import DashboardCourseOverviewLoader from '../loaderComponents/DashboardCourseOverviewLoader';
// import DashboardNewsCardLoader from "../loaderComponents/DashboardNewsCardLoader";

const getUserLevel = level => (level == 0 ? 'N/A' : `${level}00 Level`);

// component for student profile card
const StudentsProfileCard = props => (
  <AuthConsumer>
    {({ user }) => (
      <div className="row no-gutters">
        {/* card for picture and name */}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 pr-1">
          <div className="card text-center ">
            <div className="card-body">
              <div className="student-details">
                <img
                  src={user.passport}
                  className="image-rounded-circle"
                  alt="student profile avatar"
                />

                <div className="name">
                  {user.lastname.toUpperCase()}, {user.firstname}{' '}
                </div>
                <div className="matric-number">
                  {Number(user.has_matric_number)
                    ? 'Matric. No.:'
                    : 'Application No:'}{' '}
                  <span>{user.matric_number}</span>
                </div>
              </div>
              <Link to="/profile" className="btn btn-primary btn-primary-color">
                My Profile
              </Link>
            </div>
          </div>
        </div>
        {/* end card for picture and name */}
        {/* card for academic details */}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8">
          <div className="card">
            <div className="card-body">
              <div className="col-md-12">
                <button className="circle-bg-width-40 circle-bg circle-bg-gray mt-3">
                  <img
                    src={academicDetails}
                    height={20}
                    width={20}
                    className="svg"
                    alt="Academic Details"
                  />
                </button>
                <span className="card-heading-h2">Academic Details</span>
              </div>
              <div className="items">
                <div className="item-container">
                  <div className="row no-gutters">
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 pl-2">
                      <div className="item-title">Level</div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 pr-2">
                      <div className="item-details">{`${user.level}00 Level, ${
                        user.entry_mode
                      }`}</div>
                    </div>
                  </div>
                </div>
                <div className="item-container">
                  <div className="row no-gutters">
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 pl-2">
                      <div className="item-title">Programme</div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 pr-2">
                      <div className="item-details">{user.programme}</div>
                    </div>
                  </div>
                </div>
                {/*<div className="item-container">
                  <div className="row no-gutters">
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 pl-2">
                      <div className="item-title">Faculty</div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 pr-2">
                      <div className="item-details">{user.faculty}</div>
                    </div>
                  </div>
                </div>*/}

                <div className="item-container">
                  <div className="row no-gutters">
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 pl-2">
                      <div className="item-title">Exam. Center</div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 pr-2">
                      <div className="item-details">{user.exam_center}</div>
                    </div>
                  </div>
                </div>
                <div className="item-container">
                  <div className="row no-gutters">
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 pl-2">
                      <div className="item-title">Email</div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 pr-2">
                      <div className="item-details">{user.user_login}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end card for academic details */}
        </div>
        {/* end card container for student profile */}
      </div>
    )}
  </AuthConsumer>
);

const NoOutstandingFees = ({ networkError, message }) => (
  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
    {/* card for outstanding fees */}
    <div className="card">
      <div className="card-header">
        <div className="row no-gutters">
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            Oustanding Fee(s)
          </div>
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
            <a href="#" className="card-link">
              Fees <i className="fa fa-angle-right" />
            </a>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="dashboard-transaction-container">
          <div className="empty-card text-center mt-3">
            <button className="circle-bg-width-80 circle-bg circle-bg-gray">
              <img
                src={require('../assets/empty-fee.svg')}
                className="svg"
                alt="Min Unit"
              />
            </button>
            {networkError ? (
              <Fragment>
                <p>Network Error</p>
                <small>
                  Your outstanding fee(s) is/are not available, try again later
                </small>
              </Fragment>
            ) : (
              <Fragment>
                <p>No Oustanding Fee</p>
                <small>{message}</small>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

// component for outstanding fees card
class OutstandingFees extends React.Component {
  state = {
    loading: true,
    fees: [],
    sundry_fees: [],
    outstandingFee: null,
    noOutstandingFee: false,
    outstandingFeeMessage: 'Seems you have paid all fee for this session',
    networkError: false
  };

  componentDidMount() {
    FETCH.getFees()
      .then(response => {
        if (
          !response.data ||
          typeof response.data === 'string' ||
          response.status === 'error'
        ) {
          return this.setState({
            loading: false,
            noOutstandingFee: true,
            networkError: true
          });
        }
        this.setState(
          {
            fees: response.data.main_fees,
            sundry_fees: response.data.sundry_fees
          },
          () => this.getOutstandingFee()
        );
      })
      .catch(error => {
        toast(error.message, { status: 'error', timeout: 3000 });
      });
  }

  getOutstandingFee = () => {
    const { fees } = this.state;
    const allFees = fees;

    if (!fees || fees.length === 0)
      return this.setState({
        noOutstandingFee: true,
        loading: false,
        outstandingFeeMessage:
          "Seems you don't have any fee yet for this session"
      });
    let outstandingFee = allFees.find(
      fee => fee.paid === 0 || (fee.paid === 0 && fee.paid_id)
    );

    if (outstandingFee) {
      return this.setState({ outstandingFee, loading: false });
    } else {
      return this.setState({ noOutstandingFee: true, loading: false });
    }
  };

  render() {
    const {
      fees,
      loading,
      outstandingFee,
      noOutstandingFee,
      networkError,
      outstandingFeeMessage
    } = this.state;
    if (loading) return <DashboardOutstandingFeesLoader />;

    if (!loading && noOutstandingFee)
      return (
        <NoOutstandingFees
          networkError={networkError}
          message={outstandingFeeMessage}
        />
      );
    return (
      <AuthConsumer>
        {({ user }) => (
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
            <div className="card">
              <div className="card-header">
                <div className="row no-gutters">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    Oustanding Fee(s)
                  </div>
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                    <Link to="/fees" className="card-link">
                      Fees <i className="fa fa-angle-right" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="dashboard-transaction-container">
                  <div className="details">
                    <div className="big-amount-text">
                      {numberFormat(outstandingFee.amount)} <span>NGN</span>
                    </div>
                    <div className="fee-description">
                      {outstandingFee.description}{' '}
                      <span>| {user.current_session}</span>
                    </div>
                  </div>
                  <div className="button-action-container">
                    <div className="row no-gutters">
                      <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        {outstandingFee.paid === 0 && outstandingFee.paid_id ? (
                          <Link
                            className={[
                              `btn btn-primary btn-primary-color ${
                                canDisableFee(outstandingFee, fees)
                                  ? 'disabled'
                                  : ''
                              }`
                            ]}
                            to={`${
                              canDisableFee(outstandingFee, fees)
                                ? ''
                                : `transaction/details/${
                                    outstandingFee.paid_id
                                  } `
                            }`}
                          >
                            Retry Payment{' '}
                          </Link>
                        ) : (
                          <Link
                            to="/fees"
                            className={[
                              `btn btn-primary btn-primary-color ${
                                canDisableFee(outstandingFee, fees)
                                  ? 'disabled'
                                  : ''
                              }`
                            ]}
                          >
                            Make Payment
                          </Link>
                        )}
                      </div>
                      <div className="days-remaining col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <i>
                          {outstandingFee.paid === 0 &&
                          outstandingFee.paid_id ? (
                            <DaysRemainingIcon status="pending" />
                          ) : (
                            <DaysRemainingIcon status="" />
                          )}
                        </i>
                        {getDueTime(outstandingFee.date_due)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* card for outstanding fees */}
          </div>
        )}
      </AuthConsumer>
    );
  }
}

const NoLastTransaction = ({ networkError }) => (
  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
    {/* card for last transactions */}
    <div className="card">
      <div className="card-header">
        <div className="row no-gutters">
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            Last Transaction(s)
          </div>
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
            <a href="#" className="card-link">
              Transactions <i className="fa fa-angle-right" />
            </a>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="dashboard-transaction-container">
          <div className="empty-card text-center mt-3">
            <button className="circle-bg-width-80 circle-bg circle-bg-gray">
              <img
                src={require('../assets/empty-fee.svg')}
                className="svg"
                alt="Min Unit"
              />
            </button>
            {networkError ? (
              <Fragment>
                <p>Network Error</p>
                <small>
                  Your outstanding fee(s) is/are not available, try again later
                </small>
              </Fragment>
            ) : (
              <Fragment>
                <p>No Transaction(s)</p>
                <small>You have not made any payment this session</small>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
    {/* card for last transactions */}
  </div>
);

// component for Last transactons card
class LastTransactions extends React.Component {
  state = {
    loading: true,
    transactions: null,
    networkError: false
  };
  componentDidMount() {
    FETCH.getLatestTransaction()
      .then(response => {
        if (response.status === 'success' || typeof response.data != 'string') {
          return this.setState({ transactions: response.data, loading: false });
        }
        this.setState({ loading: false, networkError: true });
      })
      .catch(error => console.log(error));
  }

  generateStatusString = code =>
    code === '01' ? 'Successful' : code === '100' ? 'Pending' : 'Failed';
  render() {
    const { loading, transactions, networkError } = this.state;
    if (loading) return <DashboardLastTransactionsLoader />;
    if (!loading && !transactions)
      return <NoLastTransaction networkError={networkError} />;

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
        {/* card for last transactions */}
        <div className="card">
          <div className="card-header">
            <div className="row no-gutters">
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                Last Transaction(s)
              </div>
              <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                <Link to="/transactions" className="card-link">
                  Transactions <i className="fa fa-angle-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="dashboard-transaction-container">
              {transactions.map(transaction => {
                return (
                  <Fragment key={transaction.transaction_id}>
                    {transaction.outstanding == 0 ? (
                      <div className="small-amount-text">
                        <div className="row no-gutters">
                          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                            {numberFormat(transaction.amount_paid)}{' '}
                            <span>NGN</span>
                            <div className="status">
                              {this.generateStatusString(
                                transaction.payment_status
                              )}
                              <i>
                                {transaction.payment_status === '01' ? (
                                  <img
                                    src={transactionSuccess}
                                    className="svg transaction"
                                    alt="Academic Details"
                                  />
                                ) : (
                                  <DaysRemainingIcon
                                    status={this.generateStatusString(
                                      transaction.payment_status
                                    ).toLowerCase()}
                                  />
                                )}
                              </i>
                            </div>
                          </div>
                          <div className="dashboard-transaction-date col-xs-6 col-sm-6 col-md-6 col-lg-6">
                            <div className="title">
                              {transaction.payment_status === '01'
                                ? 'Date Paid'
                                : 'Date Perfomed'}
                            </div>
                            <div className="date">
                              {transaction.date_performed}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="small-amount-text"
                        key={transaction.transaction_id}
                      >
                        <div className="row no-gutters">
                          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                            {numberFormat(transaction.amount_paid)}{' '}
                            <span>NGN</span>
                            <div className="status">
                              Pending{' '}
                              <i>
                                <DaysRemainingIcon status="pending" />
                              </i>
                            </div>
                          </div>
                          <div className="dashboard-transaction-date col-xs-6 col-sm-6 col-md-6 col-lg-6">
                            <div className="title">Date Paid</div>
                            <div className="date">
                              {transaction.dates_performed}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Fragment>
                );
              })}
            </div>
          </div>
        </div>
        {/* card for last transactions */}
      </div>
    );
  }
}

// component for course overview card
class CourseOverview extends React.Component {
  state = {
    course_config: ''
  };
  componentDidMount() {
    // course overview slider
    FETCH.getCourseConfig().then(res => {
      this.setState({ course_config: this.group_to_sem(res.data) });
    });
  }
  group_to_sem = array => {
    let config = {
      first: {},
      second: {}
    };
    if (!array) return config;
    array.forEach(obj => {
      if (obj.semester === '1') {
        config.first = obj;
      } else {
        config.second = obj;
      }
    });
    return config;
  };
  render() {
    let { course_config } = this.state;
    return course_config ? (
      <CourseSlider config={course_config} />
    ) : (
      <DashboardCourseOverviewLoader />
    );
  }
}

class CourseSlider extends Component {
  state = {
    semester: 'first'
  };
  componentDidMount() {
    // course overview slider

    const $ = window.jQuery || window.$;
    $('.course-overview-slider').owlCarousel({
      items: 4,
      loop: false,
      margin: 20,
      dots: false,
      navText: [
        "<i class='fas fa-long-arrow-left'></i>",
        "<i class='fas fa-long-arrow-right'></i>"
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true
        },
        480: {
          items: 1,
          nav: true
        },
        576: {
          items: 1,
          nav: true
        },
        768: {
          items: 2,
          nav: true
        },
        992: {
          items: 3,
          nav: true
        },
        1200: {
          items: 4,
          nav: false,
          loop: false
        }
      }
    });
  }

  setSemester = sem => {
    this.setState({ semester: sem });
  };
  render() {
    let { semester } = this.state,
      { config } = this.props;
    return (
      <div className="row no-gutters">
        <div className="col-lg-12">
          {config ? (
            <div className="card">
              <div className="card-header">
                <div className="row no-gutters">
                  <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                    Course Overview
                  </div>
                  <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                    <span
                      onClick={() => {
                        this.setSemester('first');
                      }}
                      style={{ color: '#00d715', cursor: 'pointer' }}
                    >
                      {' '}
                      1st Semester{' '}
                    </span>{' '}
                    |{' '}
                    <span
                      onClick={() => {
                        this.setSemester('second');
                      }}
                      style={{ color: '#00d715', cursor: 'pointer' }}
                    >
                      {' '}
                      2nd Semester{' '}
                    </span>
                  </div>
                  <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-right">
                    <Link to="/courses" className="card-link">
                      Courses <i className="fa fa-angle-right" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div
                  className="course-overview-slider owl-carousel owl-theme"
                  ref={el => (this.courseOverviewSlider = el)} // get reference to .course-overview-slider to configure the couse-overview-slider
                >
                  <div className="course-overview text-center">
                    <div className="course-border">
                      <button className="circle-bg-width-48 circle-bg circle-bg-purple">
                        <img
                          src={courseMinimumUnits}
                          className="svg"
                          alt="Min Unit"
                        />
                      </button>
                      <div className="number">
                        {config[semester].min_unit || 'n/a'}
                      </div>
                      <p>Minimum Units Required</p>
                    </div>
                  </div>
                  <div className="course-overview text-center">
                    <div className="course-border">
                      <button className="circle-bg-width-48 circle-bg circle-bg-teal">
                        <img
                          src={courseMaximumUnits}
                          className="svg"
                          alt="Max Unit"
                        />
                      </button>
                      <div className="number">
                        {config[semester].max_unit || 'n/a'}
                      </div>
                      <p>Maximum Units Required</p>
                    </div>
                  </div>
                  <div className="course-overview text-center">
                    <div className="course-border">
                      <button className="circle-bg-width-48 circle-bg circle-bg-green">
                        <img
                          src={courseTotalUnits}
                          className="svg"
                          alt="Total Units Reg"
                        />
                      </button>
                      <div className="number">n/a</div>
                      <p>Total Unit Registered</p>
                    </div>
                  </div>
                  <div className="course-overview text-center">
                    <div className="border-0 course-border">
                      <button className="circle-bg-width-48 circle-bg circle-bg-amber">
                        <img
                          src={courseOutstanding}
                          className="svg"
                          alt="Outstanding Course"
                        />
                      </button>
                      <div className="number">n/a</div>
                      <p>CO/Outstanding Course(s)</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* card for outstanding fees */}
            </div>
          ) : (
            ''
          )}
          {/* end card for course max/min credit unit, total registerable, c/o & outstanding courses  */}
        </div>
      </div>
    );
  }
}

// class NewsCard extends React.Component {
//   componentDidMount() {
//     // get global jQuery object for use within component
//     this.$ = window.$;

//     // configure latest news slider
//     this.$(this.newSlider).owlCarousel({
//       items: 4,
//       loop: false,
//       margin: 0,
//       dots: false,
//       navText: [
//         "<i class='fa fa-long-arrow-left'></i>",
//         "<i class='fa fa-long-arrow-right'></i>"
//       ],
//       responsiveClass: true,
//       responsive: {
//         0: {
//           items: 1,
//           nav: true
//         },
//         480: {
//           items: 1,
//           nav: true
//         },
//         576: {
//           items: 1,
//           nav: true
//         },
//         768: {
//           items: 2,
//           nav: true
//         },
//         992: {
//           items: 3,
//           nav: true
//         },
//         1200: {
//           items: 4,
//           nav: false,
//           loop: false
//         }
//       }
//     });
//   }
//   render() {
//     return (
//       <div className="row no-gutters">
//         <div className="col-lg-12">
//           <div className="card">
//             <div className="card-header">
//               <div className="row no-gutters">
//                 <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
//                   Latest News
//                 </div>
//                 <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
//                   <a href="#" className="card-link">
//                     See All News <i className="fa fa-angle-right" />
//                   </a>
//                 </div>
//               </div>
//             </div>
//             <div className="card-body">
//               <div
//                 className="news-slider owl-carousel owl-theme"
//                 ref={el => (this.newSlider = el)} // get reference to .news-slider to configure the news-slider
//               >
//                 <div className="news-container">
//                   <div className="news-content">
//                     <div className="news-header">
//                       <div className="date-posted">Posted Today</div>
//                     </div>
//                     <div className="news-body">
//                       <p className="news-title">
//                         UniAbuja receives student experience accolade.
//                       </p>
//                       <a href="#" className="news-link">
//                         Continue Reading
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="news-container">
//                   <div className="news-content">
//                     <div className="news-header">
//                       <div className="date-posted">Posted Today</div>
//                     </div>
//                     <div className="news-body">
//                       <p className="news-title">
//                         UniAbuja receives student experience accolade.
//                       </p>
//                       <a href="#" className="news-link">
//                         Continue Reading
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="news-container">
//                   <div className="news-content">
//                     <div className="news-header">
//                       <div className="date-posted">Posted Today</div>
//                     </div>
//                     <div className="news-body">
//                       <p className="news-title">
//                         UniAbuja receives student experience accolade.
//                       </p>
//                       <a href="#" className="news-link">
//                         Continue Reading
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="news-container">
//                   <div className="news-content">
//                     <div className="news-header">
//                       <div className="date-posted">Posted Today</div>
//                     </div>
//                     <div className="news-body">
//                       <p className="news-title">
//                         UniAbuja receives student experience accolade.
//                       </p>
//                       <a href="#" className="news-link">
//                         Continue Reading
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* card for outstanding fees */}
//         </div>
//         {/* end card for news display   */}
//       </div>
//     );
//   }
// }

const Dashboard = () => {
  return (
    <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
      <h1>My Dashboard</h1>
      {/* compoonent for student profile */}
      <StudentsProfileCard />
      {/* card container for dashboard transaction */}
      <div className="row">
        <OutstandingFees />{' '}
        {/*render component based on availabilitiy of data */}
        <LastTransactions />
        {/*render component based on availabilitiy of data */}
      </div>
      {/* end card container dashboard transaction */}
      {/* card for course max/min credit unit, total registerable, c/o & outstanding courses  */}
      <CourseOverview /> {/*render component based on availabilitiy of data */}
      {/* news divider */}
      {/* <hr className="section-divider" /> */}
      {/* end news divider */}
      {/* card for news display  */}
      {/* <NewsCard/> <DashboardNewsCardLoader />{" "} */}
      {/*render component based on availabilitiy of data */}
    </main>
  );
};

export default Dashboard;
